module.exports = __webpack_public_path__ + "img/Star_2024.5fad58cd.png";